module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-tr-TR.e58b4af9.jpg";